import { z } from 'zod';
import { applyStartDateBeforeEndateOrderSchema } from './schemas/start-date-before-end-date-order.schema';
import { applyDateNotInFutureSchema } from './schemas/date-not-in-future.schema';
import { FormRule } from '../../dynamic-form.types';

const applySingleSchema = (schema: z.ZodTypeAny, rule: FormRule) => {
  switch (rule.type) {
    case 'start_date_before_end_date':
      return applyStartDateBeforeEndateOrderSchema(schema, rule);
    case 'date_not_in_future':
      return applyDateNotInFutureSchema(schema, rule);
    default:
      throw new Error(`Unsupported form rule type: ${(rule as { type: string }).type}`);
  }
};

export function buildFormSchemas(
  schema: z.ZodObject<Record<string, z.ZodTypeAny>>,
  rules: FormRule[]
) {
  let currentSchema: z.ZodObject<any> | z.ZodEffects<z.ZodTypeAny> = schema;
  rules.forEach((rule) => {
    currentSchema = applySingleSchema(currentSchema, rule);
  });

  return currentSchema;
}
